import toast from "react-hot-toast";
import { login, loginWithCode } from "../../../api/auth";
import { getSubscription, getUser } from "../../../api/user";
import { setRestaurant } from "../restaurantSlice";
import { setErrorToken, setErrorV2, setJWT, setSubscriptionV2, setUserV2, startAuthV2 } from "./authSliceV2";

//status: 'cheking' | 'not-authenticated' | 'get-user' | 'not-complete' | 'authenticated'


export const LoginV =  (data, loginRequest = login, passwordless = false) => {



    return async (dispatch) => {


        try {
          dispatch(startAuthV2())
          const token =  await loginRequest(data);


          if (token.data.app === 'restaurant') {
            dispatch(setJWT(token.data.token)) 

          const user = await getUser(token.data.token, data.phone); 
          const subscription = await getSubscription(token.data.token, user.id)
          let restaurantList = user.restaurants.map((val) => {
            return {
                id: val.restaurantId,
                name: val.restaurant,
                value: val.restaurantId,
                address: val.address,
                city: val.city,
                state: val.state,
              };
           });
        let restaurantListSelect = user.restaurants.map((val) => {
            return {
                id: val.id ? val.id : val.restaurantId,
                name: val.name ? val.name : val.restaurant,
                value: val.value ? val.value : val.restaurantId,
              };
            });
          
          dispatch(setSubscriptionV2(subscription.data))
            //Con el ingreso por código el usuario ya se validó con su celular, no se le pide completar la contraseña
            if (!user.complete && !passwordless) {


                dispatch(setUserV2({ user, status: 'not-complete', restaurant: user.restaurants[0].restaurantId, restaurantSelect:restaurantListSelect, restaurantList, passwordless}))

            }else{


              dispatch(setUserV2({ user, status: 'authenticated', restaurant: user.restaurants[0].restaurantId, restaurantSelect:restaurantListSelect, restaurantList, passwordless}))


            }
         
            
          }  else{
            dispatch( setErrorV2({
              message: 'Esta cuenta no esta registrada como comercio',
              link: process.env.SUPPLIER_PORTAL_URL,
              linkLabel: 'Ir al portal de proveedores',
            }) )
          }

          
          
           
        } catch (error) {
          dispatch( setErrorV2(error.response.data) )
      
          toast.error('Error interno. Inténtelo más tarde');
             
           
        }

              }
   }


   //Ingreso alterno con el código de un solo uso enviado al celular
   export const LoginCodeV = (data) => LoginV(data, loginWithCode, true)


   export const me =  (restaurant, token, phone ) => {



    return async (dispatch, getState) => {

            //Se mantiene el ingreso por código al recargar, para no mandarlo a completar la contraseña
            const { passwordless } = getState().auth;

            try {
              const user = await getUser(token, phone); 

              const subscription = await getSubscription(token, user.id)
                   
              dispatch(setSubscriptionV2(subscription.data))

                let restaurantList = user.restaurants.map((val) => {
                    return {
                        id: val.restaurantId,
                        name: val.restaurant,
                        value: val.restaurantId,
                        address: val.address,
                        city: val.city,
                        state: val.state,
                      };
          });
                let restaurantListSelect = user.restaurants.map((val) => {
                    return {
                        id: val.id ? val.id : val.restaurantId,
                        name: val.name ? val.name : val.restaurant,
                        value: val.value ? val.value : val.restaurantId,
                      };
          });
          if (!user.complete && !passwordless) {


            dispatch(setUserV2({ user, status: 'not-complete', restaurant: restaurant, restaurantSelect:restaurantListSelect, restaurantList, passwordless}))

        }else{


          dispatch(setUserV2({ user, status: 'authenticated', restaurant: restaurant, restaurantSelect:restaurantListSelect, restaurantList, passwordless}))


        }
               
              
               
            } catch (error) {
         
              if (error.response.data === 'Su token ha caducado por favor vuelve a iniciar sesión') {
                dispatch( setErrorToken( true ) )
              }else{
                dispatch( setErrorV2(error.response.data) )
              }

             // 
            }
              }

   }